<template>
	<div class="speed-telescope">
		<div class="info-wrap">
			<div class="head" @click="backClick">
				<img src="../assets/home/arrow_left.svg" />
				<div>望远镜加速</div>
			</div>

			<div class="content-wrap">
				<div class="telescope-text1">
					<div>望远镜：重新定义远程服务</div>
					<div>一键管理 · 一键唤醒 · 一键远程</div>
				</div>
				<div class="goods-wrap">
					<div class="goods-item">
						<div class="item-text1">
							<span
								class="standard-icon"
								v-if="$store.state.user.vip_left <= 0"
							></span>
							<div class="item-text1-1">标准版</div>
							<div class="item-text1-2">用户体验使用</div>
						</div>
						<div class="item-text">
							<div class="item-text-name">带宽大小</div>
							<div class="item-text-value">限速</div>
						</div>
						<div class="item-text">
							<div class="item-text-name">流量大小</div>
							<div class="item-text-value">限量</div>
						</div>
						<div class="item-text">
							<div class="item-text-name">服务数量</div>
							<div class="item-text-value">限量</div>
						</div>
						<div class="item-text">
							<div class="item-text-name">节点</div>
							<div class="item-text-value">全国普通节点</div>
						</div>
						<div class="item-texst-free">限时免费</div>
						<div
							class="item-btn item-btn-user"
							@click="goDefaultPageClick"
						>
							开始使用
						</div>
					</div>
					<div class="goods-item goods-item-vip">
						<div class="item-text1">
							<span
								class="standard-icon"
								v-if="$store.state.user.vip_left > 0"
							></span>
							<div class="item-text1-1">VIP会员</div>
							<div class="item-text1-2">为用户有更好体验</div>
						</div>
						<div class="item-text">
							<div class="item-text-name">高速带宽</div>
							<div class="vip-icon1"></div>
						</div>
						<div class="item-text">
							<div class="item-text-name">流量不限量</div>
							<div class="vip-icon2"></div>
						</div>
						<div class="item-text">
							<div class="item-text-name">服务数量不限量</div>
							<div class="vip-icon2"></div>
						</div>
						<div class="item-text">
							<div class="item-text-name">VIP专享高速节点</div>
							<div class="vip-icon1"></div>
						</div>
						<div class="vip-text">
							￥<span>158</span
							><span v-if="false">{{
								monthGoods.gsellprice / 100
							}}</span>
							/年
						</div>
						<div class="item-btn">敬请期待</div>
						<div
							class="item-btn"
							@click="openPayAlertClick"
							v-if="false"
						>
							立享优惠
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="pay-wrap" v-if="payAlertFlag">
			<div class="white-wrap">
				<div class="close-pay-btn" @click="closePayClick"></div>
				<div class="two-ways-wrap" v-if="payAlertItemFlag == 1">
					<div class="month-bg"></div>
					<div class="two-ways-text1">
						<div>￥</div>
						<div>{{ monthGoods.gsellprice / 100 }}</div>
					</div>
					<div class="two-ways-text2">
						原价：9.9元
						<div class="lining"></div>
					</div>
					<div class="pay-btn1" @click="openAliPayAlertClick">
						支付宝支付
					</div>
					<div class="pay-btn2" @click="openWeixinPayAlertClick">
						微信支付
					</div>
				</div>
				<div v-if="payAlertItemFlag == 2" class="wait-wrap">
					<div class="wait-head">
						<div class="ali"></div>
						<div>支付宝支付</div>
					</div>
					<div class="qrcode-wrap"></div>
					<div class="wait-text1">
						<div>￥</div>
						<div>{{ monthGoods.gsellprice / 100 }}</div>
					</div>
					<div class="wait-text2">等待支付</div>
				</div>
				<div v-if="payAlertItemFlag == 3" class="wait-wrap">
					<div class="wait-head">
						<div class="weixin"></div>
						<div>微信支付</div>
					</div>
					<div class="qrcode-wrap">
						<canvas id="weixin"></canvas>
					</div>
					<div class="wait-text1">
						<div>￥</div>
						<div>{{ monthGoods.gsellprice / 100 }}</div>
					</div>
					<div class="wait-text2">等待支付</div>
				</div>
				<div v-if="payAlertItemFlag == 4" class="success-wrap">
					<div class="success-icon" @click="closePaySuccess"></div>
					<div class="success-text1">支付成功</div>
					<div class="success-text2">支付时间：{{ payDate }}</div>
					<div class="success-btn" @click="goDefaultPageClick">
						立享极速体验
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions } from "vuex";
//import QRcode from "qrcode";

export default {
	name: "SpeedTelescope",
	components: {},
	data: function () {
		return {
			payAlertFlag: false, //支付弹框 true显示 false不显示
			payAlertItemFlag: 1, //1显示选择哪种支付方式的弹框 2支付宝支付弹框 3微信支付弹框 4支付成功弹框
			monthGoods: {}, //月卡
			checkWeixinPayIntval: null,
			outTradeNO: "",
			payDate: "",
		};
	},
	methods: {
		...mapActions(["goods", "unifiedOrder", "orderQuery", "vipLeft"]),
		backClick: function () {
			let _that = this;
			_that.payAlertFlag = false;
			// _that.$router.push({ path: "/home/speedtabs" });
			_that.$router.go(-1);
		},
		closePaySuccess: function () {
			let _that = this;
			_that.payAlertFlag = false;
			_that.payAlertItemFlag = 1;
		},
		goDefaultPageClick: function () {
			let _that = this;
			_that.closePaySuccess();
			_that.$router.push({ path: "/home/node" });
		},
		closePayClick: function () {
			let _that = this;
			_that.payAlertFlag = false;
			_that.payAlertItemFlag = 1;
			clearInterval(_that.checkWeixinPayIntval);
		},
		openPayAlertClick: function () {
			let _that = this;
			_that.payAlertFlag = true;
		},
		openAliPayAlertClick: function () {
			let _that = this;
			_that.payAlertItemFlag = 2;
		},
		openWeixinPayAlertClick: function () {
			let _that = this;
			_that.payAlertItemFlag = 3;
			_that.unifiedOrder([
				_that.monthGoods.gid,
				function (err, data) {
					if (data && data.rtn == 0) {
						if (data.data.CodeURL) {
							_that.outTradeNO = data.data.outTradeNO;

							let canvas = document.getElementById("weixin");
							/*
							QRcode.toCanvas(
								canvas,
								data.data.CodeURL,
								{ width: 167, height: 167 },
								function (error) {
									if (error) {
										console.error(error);
										return;
									}

									clearInterval(_that.checkWeixinPayIntval);

									_that.checkWeixinPayIntval = setInterval(
										function () {
											_that.orderQuery([
												_that.outTradeNO,
												function (err, data) {
													if (data && data.rtn == 0) {
														if (
															data.data
																.trade_state ==
															"SUCCESS"
														) {
															_that.payDate =
																new Date().Format(
																	"yyyy年MM月dd日 hh:mm:ss"
																);
															_that.payAlertItemFlag = 4;
															_that.getVipLeft();

															setTimeout(
																function () {
																	clearInterval(
																		_that.checkWeixinPayIntval
																	);
																},
																1000
															);
														}
													}
												},
											]);
										},
										5000
									);
								}
							);
							*/
						}
					}
				},
			]);
		},
		getVipLeft: function () {
			let _that = this;
			_that.vipLeft([function () {}]);
		},
	},
	computed: {},

	mounted() {
		let _that = this;

		_that.goods([
			function (err, data) {
				if (data && data.rtn == 0) {
					_that.monthGoods = data.data[0];
				}
			},
		]);
	},
};
</script>
<style lang="less" scoped>
.speed-telescope {
	height: 100%;

	.info-wrap {
		position: relative;

		.head {
			position: absolute;
			top: 0;
			z-index: 1;
			width: 915px;
			height: 48px;
			line-height: 48px;
			background-color: #e8f5fe;
			font-size: 14px;
			color: #294075;
			box-shadow: 0 5px 10px -5px rgba(193, 193, 193, 0.5);

			img {
				margin-left: 31px;
				margin-right: 3px;
				margin-top: 18px;
				width: 16px;
				height: 13px;
				cursor: pointer;
				display: inline-block;
				vertical-align: top;
			}
			div {
				cursor: pointer;
				display: inline-block;
				vertical-align: top;
			}
		}

		.content-wrap {
			position: relative;
			margin: 0 auto;
			width: 895px;
			height: 523px;
			box-sizing: border-box;
			border-bottom-right-radius: 3px;
			border-bottom-left-radius: 3px;
			background-image: url("../assets/speedTelescope/bg.png");
			background-position: center;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			overflow: hidden;

			.telescope-text1 {
				margin-top: 90px;
				text-align: center;
				font-size: 18px;
				color: #294075;
				div {
					line-height: 28px;
				}
				div:nth-of-type(1) {
					font-weight: bold;
				}
			}
			.goods-wrap {
				text-align: center;

				.goods-item {
					margin-top: 30px;
					width: 294px;
					height: 307px;
					box-sizing: border-box;
					border-radius: 7px;
					background-color: #ffffff;
					overflow: hidden;
					box-shadow: 0px 0px 10px 0px rgba(193, 193, 193, 0.8);
					display: inline-block;
					vertical-align: top;

					.item-text1 {
						position: relative;
						padding-top: 15px;
						margin-bottom: 12px;
						width: 100%;
						height: 77px;
						background-color: #d6deed;
						background-image: linear-gradient(
							to right,
							#d6deed,
							#a6b5d0
						);
						text-align: center;
						color: #f5f5f5;
						box-sizing: border-box;

						.standard-icon {
							position: absolute;
							top: -6px;
							left: -6px;
							width: 74px;
							height: 74px;
							background-image: url("../assets/speedTelescope/goods1.svg");
							background-repeat: no-repeat;
							background-size: 100% 100%;
							background-position: center;
						}

						.item-text1-1 {
							font-size: 16px;
							font-weight: bold;
						}
						.item-text1-2 {
							margin-top: 5px;
							font-size: 14px;
						}
					}
					.item-text {
						margin: 0 auto;
						padding-left: 30px;
						padding-right: 30px;
						width: 233px;
						height: 31px;
						color: #666666;
						font-size: 12px;
						box-sizing: border-box;
						line-height: 31px;
						div {
							vertical-align: top;
						}
						.item-text-name {
							text-align: left;
							float: left;
						}
						.item-text-value {
							text-align: right;
							float: right;
						}
					}
					.item-text:nth-child(even) {
						background-color: rgba(246, 246, 246, 0.68);
					}

					.item-texst-free {
						margin-top: 15px;
						text-align: center;
						font-size: 20px;
						color: #000000;
					}

					.item-btn-user {
						cursor: pointer;
						opacity: 0.8;
					}

					.item-btn {
						margin: 0 auto;
						margin-top: 12px;
						width: 107px;
						height: 28px;
						line-height: 28px;
						text-align: center;
						color: #f5f5f5;
						font-weight: bold;
						font-size: 12px;
						background-color: #d6deed;
						background-image: linear-gradient(
							to right,
							#d6deed,
							#a6b5d0
						);
						border-radius: 20px;
						box-shadow: 0px 0px 3px 0px rgba(193, 193, 193, 0.5);
					}
				}

				.goods-item-vip {
					margin-left: 27px;

					.item-text1 {
						background-color: #faaf1b;
						background-image: linear-gradient(
							to right,
							#fcc11a,
							#faaf1b
						);

						.item-text1-1 {
							display: inline-block;
							padding-left: 22px;
							background-image: url("../assets/speedTelescope/goods2.svg");
							background-size: 18px 18px;
							background-position: left center;
							background-repeat: no-repeat;
						}
						.item-text1-2 {
							margin-top: 4px;
						}
					}

					.item-text {
						.vip-icon1 {
							width: 20px;
							height: 20px;
							background-image: url("../assets/speedTelescope/goods3.svg");
							background-size: 100% 100%;
							background-position: center;
							background-repeat: no-repeat;
							float: right;
							margin-top: 5px;
						}
						.vip-icon2 {
							width: 20px;
							height: 20px;
							background-image: url("../assets/speedTelescope/goods4.svg");
							background-size: 100% 100%;
							background-position: center;
							background-repeat: no-repeat;
							float: right;
							margin-top: 5px;
						}
					}
					.vip-text {
						margin-top: 10px;
						text-align: center;
						font-size: 12px;
						span {
							font-size: 27px;
						}
					}

					.item-btn {
						margin-top: 8px;
						background-color: #faaf1b;
						background-image: linear-gradient(
							to right,
							#fcc11a,
							#faaf1b
						);
					}
				}
			}
		}
	}

	.pay-wrap {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
		width: 100%;
		height: 100%;
		background-color: rgba(81, 81, 81, 0.35);

		.white-wrap {
			position: absolute;
			top: 50%;
			left: 473px;
			transform: translate(0, -50%); //向左移动自身宽度的50%
			width: 296px;
			height: 366px;
			background-color: #f4f4f4;
			border-radius: 7px;
			box-sizing: border-box;
			box-shadow: 0px 0px 5px 2px rgba(193, 193, 193, 0.5);

			.close-pay-btn {
				position: absolute;
				right: 14px;
				top: 14px;
				width: 20px;
				height: 20px;
				background-image: url("../assets/speedTelescope/close.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				background-position: center;
				cursor: pointer;
			}

			.two-ways-wrap {
				padding-top: 1px;
				.month-bg {
					margin: 0 auto;
					margin-top: 40px;
					width: 255px;
					height: 105px;
					background-image: url("../assets/speedTelescope/month.svg");
					background-repeat: no-repeat;
					background-size: 100% 100%;
					background-position: center;
				}

				.two-ways-text1 {
					margin-top: 20px;
					display: flex;
					justify-content: center;

					div:nth-child(1) {
						margin-top: 15px;
						font-size: 12px;
						font-weight: bold;
						color: #666666;
						transform: scale(0.85);
					}
					div:nth-child(2) {
						height: 35px;
						line-height: 35px;
						font-size: 41px;
						font-weight: bold;
						color: #1a1a1a;
					}
				}
				.two-ways-text2 {
					position: relative;
					margin-top: 8px;
					text-align: center;
					font-size: 12px;
					color: #666666;
					transform: scale(0.85);

					.lining {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: 69px;
						height: 1px;
						background-color: #999999;
					}
				}
				.pay-btn1,
				.pay-btn2 {
					margin: 0 auto;
					width: 201px;
					height: 36px;
					line-height: 36px;
					text-align: center;
					border-radius: 31px;
					font-size: 12px;
					color: #f5f5f5;
					cursor: pointer;
					box-shadow: 0px 0px 5px 2px rgba(193, 193, 193, 0.5);
				}
				.pay-btn1 {
					margin-top: 39px;
					background-color: #1477fe;
				}
				.pay-btn2 {
					margin-top: 10px;
					background-color: #2ec100;
				}
			}

			.wait-wrap {
				padding-top: 33px;
				.wait-head {
					display: flex;
					justify-content: center;
					align-items: center;
					color: #1a1a1a;
					font-size: 15px;
					font-weight: bold;

					.weixin,
					.ali {
						/*margin-top: 1px;*/
						margin-right: 3px;
						width: 23px;
						height: 20px;
						background-image: url("../assets/speedTelescope/weixin.svg");
						background-repeat: no-repeat;
						background-size: 100% 100%;
						background-position: center;
					}
					.ali {
						width: 27px;
						height: 27px;
						background-image: url("../assets/speedTelescope/ali.svg");
					}
				}
				.qrcode-wrap {
					margin: 0 auto;
					margin-top: 10px;
					width: 167px;
					height: 167px;
				}
				.wait-text1 {
					margin-top: 20px;
					display: flex;
					justify-content: center;

					div:nth-child(1) {
						margin-top: 15px;
						font-size: 12px;
						font-weight: bold;
						color: #666666;
						transform: scale(0.85);
					}
					div:nth-child(2) {
						height: 35px;
						line-height: 35px;
						font-size: 41px;
						font-weight: bold;
						color: #1a1a1a;
					}
				}
				.wait-text2 {
					padding-left: 2px;
					margin-top: 5px;
					text-align: center;
					color: #f88554;
					font-size: 12px;
					transform: scale(0.85);
				}
			}

			.success-wrap {
				padding-top: 74px;
				text-align: center;
				.success-icon {
					margin: 0 auto;
					width: 57px;
					height: 57px;
					background-image: url("../assets/speedTelescope/success.svg");
					background-repeat: no-repeat;
					background-size: 100% 100%;
					background-position: center;
				}
				.success-text1 {
					margin-top: 31px;
					color: #0bae08;
					font-size: 17px;
					font-weight: bold;
				}
				.success-text2 {
					margin-top: 8px;
					font-size: 13px;
					color: #999999;
				}
				.success-btn {
					margin: 0 auto;
					margin-top: 70px;
					width: 204px;
					height: 48px;
					line-height: 48px;
					border-radius: 102px;
					background-color: #f0af2d;
					background-image: linear-gradient(
						to right,
						#f9c357,
						#f0af2d
					);
					color: #ffffff;
					font-size: 14px;
				}
				.success-btn:hover {
					cursor: pointer;
					opacity: 0.9;
				}
			}
		}
	}
}
</style>
